"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportPromptRequestSchema = exports.MAX_TRANG_MOI_LAN_XUAT = exports.ExportRecommendationsRequestSchema = exports.ExportFormatSchema = exports.RecommendationListSchema = exports.RecommendationRowSchema = exports.BenchmarkSchema = exports.AddPageRequestSchema = exports.UpdatePageRequestSchema = exports.PageDetailSchema = exports.TrashRowSchema = exports.RegistryPageSchema = exports.RegistryQuerySchema = exports.RegistryFilterSchema = exports.RegistrySortSchema = exports.RegistryScopeSchema = exports.RegistryRowSchema = void 0;
const zod_1 = require("zod");
const analysis_1 = require("./analysis");
const invariant_1 = require("./invariant");
const content_1 = require("./content");
const query_1 = require("./query");
const review_1 = require("./review");
const speed_1 = require("./speed");
/** Kiểu dữ liệu API trả về cho giao diện. Dùng chung apps/api và apps/admin. */
/** Một dòng trong bảng Registry — PRS §3 */
exports.RegistryRowSchema = zod_1.z.object({
    id: zod_1.z.number().int(),
    code: zod_1.z.string(),
    slug: zod_1.z.string(),
    publicUrl: zod_1.z.string(),
    title: zod_1.z.string().nullable(),
    seoScore: zod_1.z.number().int().nullable(),
    /** Điểm của lần quét trước — để hiện mũi tên tăng/giảm, như mockup */
    prevScore: zod_1.z.number().int().nullable(),
    wordCount: zod_1.z.number().int().nullable(),
    h1Count: zod_1.z.number().int().nullable(),
    /** Số mục chưa đạt (warn + bad) */
    problemCount: zod_1.z.number().int().nullable(),
    /** Số mục ở mức bad */
    badCount: zod_1.z.number().int().nullable(),
    lastScannedAt: zod_1.z.coerce.date().nullable(),
    /** Người phụ trách — null với trang seed sẵn, chưa ai nhận */
    ownerId: zod_1.z.number().int().nullable(),
    ownerName: zod_1.z.string().nullable(),
    /**
     * Lần quét gần nhất nghi trang dựng bằng JavaScript (spec SC-15).
     * Danh sách hiện dấu hiệu này để người dùng không so điểm giữa hai trang mà
     * một trong hai đọc hụt nội dung.
     */
    renderWarning: zod_1.z.boolean().default(false),
});
/**
 * Phạm vi xem danh sách trang — spec SC-03 §3.2.
 * `all` chỉ Web Administrator dùng được; vai trò khác gửi lên thì bị bỏ qua
 * (không báo lỗi, tránh để người ta dò xem có gì ngoài phạm vi của mình).
 */
exports.RegistryScopeSchema = zod_1.z.enum(['mine', 'all']).default('mine');
/**
 * Truy vấn danh sách trang — spec SC-13 §2.3.
 *
 * Lọc, tìm và sắp xếp chuyển XUỐNG DB. Trước đây `GET /api/registry` trả toàn bộ
 * danh sách rồi trình duyệt tự lọc; với vài chục trang thì ổn, nhưng khi Web
 * Administrator xem chế độ "Tất cả" trên hàng trăm trang thì một lượt gọi kéo về
 * hàng nghìn dòng kèm hai bản ghi quét mỗi dòng.
 */
exports.RegistrySortSchema = zod_1.z
    .enum(['code', 'seoScore', 'wordCount', 'problemCount', 'lastScannedAt'])
    .default('seoScore');
exports.RegistryFilterSchema = zod_1.z.enum(['all', 'low', 'unscanned']).default('all');
exports.RegistryQuerySchema = zod_1.z.object({
    page: zod_1.z.coerce.number().int().min(1).default(1),
    /** Trần 100: một lượt gọi kéo về nhiều hơn thế là dấu hiệu ai đó đang lách phân trang. */
    pageSize: zod_1.z.coerce.number().int().min(1).max(100).default(25),
    scope: exports.RegistryScopeSchema,
    q: zod_1.z.string().trim().max(120).optional(),
    filter: exports.RegistryFilterSchema,
    sort: exports.RegistrySortSchema,
    // KHÔNG dùng `z.coerce.boolean()` — xem lý do ở `query.ts`. Chính chỗ này
    // là nơi bẫy đó làm nút sắp xếp giảm dần không hoạt động từ 10/08.
    asc: query_1.QueryBooleanSchema.default(true),
});
exports.RegistryPageSchema = zod_1.z.object({
    rows: zod_1.z.array(exports.RegistryRowSchema),
    total: zod_1.z.number().int(),
    page: zod_1.z.number().int(),
    pageSize: zod_1.z.number().int(),
    /**
     * Thống kê tính trên TOÀN BỘ phạm vi, không chỉ trang đang xem — bốn ô số liệu
     * ở đầu màn danh sách phải nói về cả danh sách, nếu không chúng đổi giá trị mỗi
     * lần bấm sang trang và mất hết ý nghĩa.
     */
    tongKet: zod_1.z.object({
        tongSoTrang: zod_1.z.number().int(),
        diemTrungBinh: zod_1.z.number().int().nullable(),
        /** Số trang bị loại khỏi điểm trung bình vì nghi đọc hụt (spec SC-15) */
        boQuaVìDocHut: zod_1.z.number().int(),
        canChuY: zod_1.z.number().int(),
        tongMucChuaDat: zod_1.z.number().int(),
    }),
});
/** Một dòng trong thùng rác — spec SC-13 §2.1. */
exports.TrashRowSchema = zod_1.z.object({
    id: zod_1.z.number().int(),
    code: zod_1.z.string(),
    slug: zod_1.z.string(),
    publicUrl: zod_1.z.string(),
    deletedAt: zod_1.z.coerce.date(),
    deletedByName: zod_1.z.string().nullable(),
    /** Số lần quét sẽ mất nếu xoá vĩnh viễn — con số THẬT, không nói chung chung */
    scanCount: zod_1.z.number().int(),
    /** Còn bao nhiêu ngày nữa thì tự dọn */
    conLaiNgay: zod_1.z.number().int(),
});
/** Chi tiết một trang: ảnh chụp gần nhất + toàn bộ mục kiểm tra */
exports.PageDetailSchema = zod_1.z.object({
    id: zod_1.z.number().int(),
    code: zod_1.z.string(),
    slug: zod_1.z.string(),
    publicUrl: zod_1.z.string(),
    scores: analysis_1.ScoreSetSchema.nullable(),
    potential: analysis_1.ScoreSetSchema.nullable(),
    prevScores: analysis_1.ScoreSetSchema.nullable(),
    lastScannedAt: zod_1.z.coerce.date().nullable(),
    /** Người phụ trách trang. Null với các trang seed sẵn, chưa ai nhận. */
    ownerName: zod_1.z.string().nullable(),
    ownerId: zod_1.z.number().int().nullable(),
    snapshot: analysis_1.PageSnapshotSchema.nullable(),
    checks: zod_1.z.array(analysis_1.CheckItemSchema),
    /**
     * Sáu luật bất biến đang bật cho trang này (spec SC-01). Mảng rỗng = tắt hết,
     * khi đó giao diện ẩn hẳn tab "Bất biến site".
     */
    invariantChecks: zod_1.z.array(zod_1.z.enum(invariant_1.INVARIANT_CHECK_CODES)).default([]),
    /**
     * Người đang xem có được sửa thiết lập / sửa tên / xoá trang này không.
     * Tính ở API để giao diện không phải tự suy lại luật phân quyền — suy sai ở
     * hai nơi là kiểu lỗi khó thấy nhất.
     */
    canManage: zod_1.z.boolean().default(false),
    /** Spec SC-15 — lần quét gần nhất có nghi trang dựng bằng JavaScript không */
    renderWarning: zod_1.z.boolean().default(false),
    renderSignals: zod_1.z.array(analysis_1.RenderSignalSchema).default([]),
    /**
     * Thay đổi phát hiện được ở LẦN QUÉT MỚI NHẤT — spec SC-19 §4 Y3.
     *
     * Gửi kèm chi tiết trang thay vì để giao diện gọi thêm một lượt: dải cảnh báo
     * "trang vừa bị gắn noindex" phải hiện NGAY khi mở màn, mà một lượt gọi thứ hai
     * thì có nhịp trang đã vẽ xong rồi cảnh báo mới nhảy vào.
     */
    changes: zod_1.z.array(review_1.PageChangeRowSchema).default([]),
    /**
     * Lần đo tốc độ thật gần nhất — spec SC-18. Null khi chưa đo bao giờ; giao diện
     * khi đó hiện nút mời đo thay vì một khối rỗng.
     */
    speed: speed_1.SpeedMeasurementSchema.nullable().default(null),
    /**
     * Trang có nằm trong lượt quét tự động hàng tuần không — spec SC-08 §4.2.
     *
     * `.default(true)` khớp mặc định của cột trong DB: một trang thêm trước spec
     * này mà giao diện vẽ công tắc ở vị trí tắt là nói sai với người dùng về việc
     * hệ thống có đang canh trang đó hay không.
     */
    weeklyRescan: zod_1.z.boolean().default(true),
});
/**
 * Thêm một trang vào Registry — sản phẩm độc lập nên người dùng tự thêm trang,
 * thay cho danh sách seed cố định (change request 2026-08-07 §2.2).
 */
/**
 * Sửa thông tin trang.
 *
 * KHÔNG cho đổi `url`: điểm số và lịch sử quét gắn với đúng một địa chỉ, đổi URL là
 * đổi đối tượng theo dõi nên số liệu cũ thành vô nghĩa. Muốn theo dõi trang khác thì
 * thêm trang mới rồi xoá trang cũ.
 */
exports.UpdatePageRequestSchema = zod_1.z
    .object({
    name: zod_1.z.string().trim().min(1, 'Tên không được để trống').max(60).optional(),
    /** Chuyển người phụ trách. `null` để bỏ trống. */
    ownerId: zod_1.z.number().int().positive().nullable().optional(),
    /**
     * Bật/tắt luật bất biến (spec SC-01). Gửi cả mảng chứ không gửi từng cờ:
     * "bật đúng những mã này" là một phép gán, không phải một chuỗi thao tác,
     * nên hai người sửa cùng lúc không trộn ra trạng thái không ai chọn.
     */
    invariantChecks: zod_1.z.array(zod_1.z.enum(invariant_1.INVARIANT_CHECK_CODES)).optional(),
    /**
     * Cho trang này vào lượt quét tự động hàng tuần hay không — spec SC-08 §4.2.
     * Mặc định BẬT; người dùng tắt cho trang ít đổi.
     */
    weeklyRescan: zod_1.z.boolean().optional(),
})
    .refine((v) => Object.keys(v).length > 0, { message: 'Không có gì để sửa' });
exports.AddPageRequestSchema = zod_1.z.object({
    url: zod_1.z.string().trim().min(1, 'Chưa nhập địa chỉ trang').url('Địa chỉ trang không hợp lệ'),
    /**
     * Tên gọi để nhận ra trang trong danh sách. Bỏ trống thì suy từ URL.
     * Không cho phép rỗng-sau-khi-trim để tránh tạo tên toàn dấu cách.
     */
    name: zod_1.z.string().trim().min(1).max(60).optional(),
});
/**
 * Internal Benchmark — PRS §8.
 * So một trang với các trang sản phẩm khác trong cùng site để thấy chênh lệch nội bộ.
 */
exports.BenchmarkSchema = zod_1.z.object({
    metric: zod_1.z.string(),
    label: zod_1.z.string(),
    value: zod_1.z.number(),
    siteAverage: zod_1.z.number(),
    /** Thứ hạng trong toàn bộ Registry, 1 là tốt nhất */
    rank: zod_1.z.number().int(),
    total: zod_1.z.number().int(),
    /** true nếu chỉ số này càng cao càng tốt */
    higherIsBetter: zod_1.z.boolean(),
});
/*
 * `ScanAllResult` đã BỎ ở spec SC-08 §4.3: quét cả danh sách không còn chạy đồng
 * bộ nên không còn "kết quả" nào để trả về lúc lượt gọi kết thúc. Thay bằng
 * `ScanProgress` ở `bao-cao.ts` — lượt gọi trả ngay một mã theo dõi, giao diện
 * hỏi tiến độ theo nhịp.
 */
/* ────────────────────────────────────────────────────────────────────────────
 * Đề xuất chỉnh sửa — spec SC-02
 * ──────────────────────────────────────────────────────────────────────────── */
/** Một đề xuất đã lưu, kèm mốc thời gian để xem lại lịch sử. */
exports.RecommendationRowSchema = content_1.RecommendationSchema.extend({
    scanId: zod_1.z.number().int(),
    createdAt: zod_1.z.coerce.date(),
});
exports.RecommendationListSchema = zod_1.z.object({
    /** Lần quét mà danh sách này thuộc về; null khi trang chưa quét lần nào */
    scanId: zod_1.z.number().int().nullable(),
    scannedAt: zod_1.z.coerce.date().nullable(),
    /**
     * Lần quét bị nghi đọc hụt nội dung (spec SC-15) — khi đó nhóm đề xuất về
     * nội dung bị bỏ qua và giao diện phải nói rõ vì sao danh sách ngắn hơn.
     */
    renderWarning: zod_1.z.boolean(),
    items: zod_1.z.array(exports.RecommendationRowSchema),
});
/**
 * Hai kiểu file tải về — spec SC-20 §3.1.
 *
 * `huong-dan` viết cho NGƯỜI đọc rồi tự dán; `prompt` viết cho một AI **đang có
 * mã nguồn trong tay** (Claude Code, Cursor…) đọc rồi tự sửa. Khác nhau ở người
 * nhận chứ không phải ở định dạng, nên cùng một dữ liệu sinh ra hai văn bản khác
 * hẳn nhau: bản prompt có vai trò, luật cấm và tiêu chí nghiệm thu; bản hướng dẫn
 * thì không cần vì người đọc đã biết mấy thứ đó.
 */
exports.ExportFormatSchema = zod_1.z.enum(['huong-dan', 'prompt']);
/** Chọn vài đề xuất rồi tải về một file hướng dẫn dán tay (spec SC-02 §3.5). */
exports.ExportRecommendationsRequestSchema = zod_1.z.object({
    ids: zod_1.z.array(zod_1.z.string().min(1)).min(1, 'Chưa chọn đề xuất nào để tải'),
    /** Thiếu thì ra bản hướng dẫn — giữ nguyên hành vi có trước SC-20. */
    format: exports.ExportFormatSchema.default('huong-dan'),
});
/**
 * Trần số trang cho một lần xuất gộp — spec SC-20 §3.2.
 *
 * Không phải giới hạn kỹ thuật của máy chủ mà là giới hạn của phía nhận: 20 trang
 * đã là file vài trăm KB, quá cửa sổ ngữ cảnh của phần lớn công cụ AI. Cho xuất
 * 100 trang thì file vẫn tải về được nhưng AI đọc hụt nửa sau mà không ai biết.
 */
exports.MAX_TRANG_MOI_LAN_XUAT = 20;
/** Xuất một file prompt gộp nhiều trang — spec SC-20 §3.2. */
exports.ExportPromptRequestSchema = zod_1.z.object({
    slugs: zod_1.z
        .array(zod_1.z.string().min(1))
        .min(1, 'Chưa chọn trang nào để xuất')
        .max(exports.MAX_TRANG_MOI_LAN_XUAT, `Mỗi lần xuất tối đa ${exports.MAX_TRANG_MOI_LAN_XUAT} trang`),
    /**
     * Bỏ hẳn mục Tier C khỏi file. Mặc định là GIỮ: chúng nằm ở một mục riêng cuối
     * mỗi trang, ghi rõ "không được tự sửa" — bỏ mặc định thì người dùng không biết
     * là có những mục đó tồn tại.
     */
    boQuaTierC: zod_1.z.boolean().default(false),
});
//# sourceMappingURL=api.js.map